import { Modal } from "react-bootstrap";
import DataLoader from "../../../../Utils/DataLoader";

export default function ViewAllDealsModal({
    show,
    onHide,
    sliderData,
    grpGliderData,
    isLoading,
    onLoadMoreForYelp,
    onLoadMoreForGrp,
    activeSource
}) {
    const yelpDeals = sliderData?.data?.data?.businesses || [];
    const grouponDeals =
  grpGliderData?.data?.data?.data?.travelExperienceProducts?.resultList || [];


    const truncate = (text, max = 30) =>
        text && text.length > max ? text.slice(0, max) + "..." : text;

    const renderCard = (item) => {
        const isGroupon = !!item.advertiserName;

        const title = item.name || item.title;
        const image = item.image_url || item.imageLink;
        const link = item.url || item.link || item.linkCode?.clickUrl;

        const categories = item.categories || [];
        const description = item.description;
        const location = item.location;
        const categoryText = categories.map(c => c.title).join(", ");

        return (
            <div className="resorts-box p-3 bg-white h-100">
                <figure>
                    <img
                        src={image}
                        alt={title}
                        className="img-fluid"
                        loading="lazy"
                    />
                </figure>

                <div className="resorts-content-box">
                    {/* Rating */}
                    {item.rating && (
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="rating-star">
                                <i className="fa-solid fa-star"></i> {item.rating}
                                {item.review_count && (
                                    <small className="ms-1">({item.review_count})</small>
                                )}
                            </span>
                        </div>
                    )}

                    {/* Title */}
                    <div className="resort-description border-0 m-0 pb-1">
                        <h3 className="mt-2">{truncate(title)}</h3>
                    </div>

                    {/* Description / Categories */}
                    {description && (
                        <p className="text-muted small mt-0 mb-1">
                            {truncate(description)}
                        </p>
                    )}

                    {categories.length > 0 && (
                        <p
                            className="text-muted small mt-0 mb-1"
                            title={categoryText}
                        >
                            {truncate(categoryText)}
                        </p>
                    )}

                    {/* Location */}
                    {location?.display_address && (
                        <p className="text-muted small">
                            {location.display_address.join(", ")}
                        </p>
                    )}

                    {/* CTA */}
                    <div className="book-trip-btn mt-2">
                        <a
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-100 text-center d-block"
                        >
                            {isGroupon ? "View Deal" : "View on Yelp"}
                        </a>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Modal show={show} onHide={onHide} centered size="xl" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>All Deals</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {isLoading && (
                    <div className="d-flex justify-content-center py-4">
                        <DataLoader />
                    </div>
                )}

                {/* Yelp */}
                {activeSource === "yelp" && yelpDeals.length > 0 && (
                    <>
                        <h5 className="mb-3">Yelp Deals</h5>
                        <div className="row">
                            {yelpDeals.map((item, index) => (
                                <div className="col-lg-4 col-md-6 mb-3" key={item.id || index}>
                                    {renderCard(item)}
                                </div>
                            ))}
                        </div>

                        <div className="text-center mt-3">
                            <button
                                className="btn btn-outline-primary"
                                onClick={onLoadMoreForYelp}
                                disabled={isLoading || yelpDeals.length >= 50}
                            >
                                {yelpDeals.length >= 50 ? "No more results" : "Load More"}
                            </button>
                        </div>
                    </>
                )}

                {/* Groupon */}
                {activeSource === "groupon" && grouponDeals.length > 0 && (
                    <>
                        <h5 className="mt-4 mb-3">Groupon Deals</h5>
                        <div className="row">
                            {grouponDeals.map((item, index) => (
                                <div className="col-lg-4 col-md-6 mb-3" key={index}>
                                    {renderCard(item)}
                                </div>
                            ))}
                        </div>

                        <div className="text-center mt-3">
                            <button
                                className="btn btn-outline-primary"
                                onClick={onLoadMoreForGrp}
                                disabled={isLoading || grouponDeals.length >= 50}
                            >
                                {grouponDeals.length >= 50 ? "No more results" : "Load More"}
                            </button>

                        </div>
                    </>
                )}



            </Modal.Body>
        </Modal>
    );
}
